import React from 'react';
import { SvgIcon } from '@mui/material';
import { shape } from 'prop-types';

const MagellanLogoColored = props => (
  <SvgIcon
    classes={props.classes}
    sx={{ enableBackground: 'new 0 0 217 31', ...props.sx }}
    viewBox="0 0 217 31"
  >
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-1"
      points="42.7,24 40.5,29.1 40.5,29.1 38.3,24 37,24 37,30 37.7,30 37.7,24.4 37.8,24.4 40.2,30 
40.8,30 43.2,24.4 43.3,24.4 43.3,30 44,30 44,24 "
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-2"
      points="48.3,30 48.7,30 48.7,24 48.3,24 "
    />
    <g id="Group-7" transform="translate(52.000000, 23.000000)">
      <path
        d="M1.4,6.1h1.4c1.6,0,2.5-0.9,2.5-2.6C5.3,1.9,4.4,1,2.8,1H1.4V6.1z M0.7,0.5h2.1
c2.3,0,3.2,1.4,3.2,3c0,1.6-0.9,3-3.2,3H0.7V0.5z"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-3"
      />
      <path
        d="M9.1,4.9c0.3,0.9,0.9,1.3,2.1,1.3c0.9,0,1.5-0.5,1.5-1.2c0-1.6-4-1-4-3c0-0.9,0.8-1.6,2.1-1.6
c1.2,0,2,0.5,2.4,1.4L12.6,2c-0.3-0.7-0.8-1.1-1.8-1.1C10,0.9,9.4,1.3,9.4,2c0,0.4,0.1,0.7,1.5,1.1c2.1,0.6,2.5,1,2.5,1.9
c0,1-1.1,1.6-2.2,1.6C9.7,6.6,8.9,6.1,8.5,5L9.1,4.9z"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-5"
      />
    </g>
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-8"
      points="69,24 69,24.4 71.2,24.4 71.2,30 71.8,30 71.8,24.4 74,24.4 74,24 "
    />
    <path
      d="M77.7,26.8h1.8c1,0,1.6-0.4,1.6-1.2c0-0.7-0.5-1.2-1.6-1.2h-1.8V26.8z M82,30h-0.7l-1.7-2.7h-1.9
V30H77v-6h2.5c1.4,0,2.3,0.6,2.3,1.6c0,0.8-0.5,1.3-1.5,1.5L82,30z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-9"
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-11"
      points="86,24 86,30 90,30 90,29.6 86.6,29.6 86.6,27.1 88.9,27.1 88.9,26.7 86.6,26.7 86.6,24.4 
89.8,24.4 89.8,24 "
    />
    <path
      d="M94.5,24L92,30h0.7l0.8-2h2.9l0.8,2H98l-2.4-6H94.5z M95,24.4L95,24.4l1.3,3.1h-2.6L95,24.4z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-12"
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-13"
      points="106.7,24 104.5,29.1 104.5,29.1 102.3,24 101,24 101,30 101.7,30 101.7,24.4 101.8,24.4 
104.2,30 104.8,30 107.2,24.4 107.3,24.4 107.3,30 108,30 108,24 "
    />
    <path
      d="M116.7,26.9h1.6c1.4,0,1.9-0.4,1.9-1.2s-0.6-1.2-1.9-1.2h-1.6V26.9z M116,30v-6h2.4
c1.9,0,2.6,0.7,2.6,1.7c0,1-0.8,1.7-2.6,1.7h-1.6V30H116z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-14"
    />
    <path
      d="M125.5,24l-2.5,6h0.7l0.8-2h2.9l0.8,2h0.7l-2.4-6H125.5z M126,24.4L126,24.4l1.3,3.1h-2.6
L126,24.4z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-16"
    />
    <path
      d="M132.7,26.8h1.8c1,0,1.6-0.4,1.6-1.2c0-0.7-0.5-1.2-1.6-1.2h-1.8V26.8z M137,30h-0.7l-1.7-2.7
h-1.9V30H132v-6h2.5c1.4,0,2.3,0.6,2.3,1.6c0,0.8-0.5,1.3-1.5,1.5L137,30z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-17"
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-19"
      points="140,24 140,24.4 142.2,24.4 142.2,30 142.8,30 142.8,24.4 145,24.4 145,24 "
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-20"
      points="152.4,24 152.4,29 152.3,29 149.1,24 148,24 148,30 148.6,30 148.6,24.4 148.7,24.4 
152.3,30 153,30 153,24 "
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-21"
      points="158,24 158,30 162,30 162,29.6 158.6,29.6 158.6,27.1 160.9,27.1 160.9,26.7 158.6,26.7 
158.6,24.4 161.8,24.4 161.8,24 "
    />
    <g id="Group-26" transform="translate(165.000000, 23.000000)">
      <path
        d="M1,3.3h1.8c1,0,1.6-0.4,1.6-1.2S3.8,1,2.8,1H1V3.3z M5.3,6.5H4.5L2.9,3.8H1v2.7H0.3v-6h2.4
C4.2,0.5,5,1.2,5,2.2c0,0.8-0.5,1.3-1.5,1.5L5.3,6.5z"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-22"
      />
      <path
        d="M8.6,4.9c0.3,0.9,0.9,1.3,2.1,1.3c0.9,0,1.4-0.5,1.4-1.2c0-1.6-3.9-1-3.9-3
c0-0.9,0.7-1.6,2.1-1.6c1.1,0,2,0.5,2.3,1.4L12,2c-0.3-0.7-0.8-1.1-1.7-1.1C9.4,0.9,8.9,1.3,8.9,2c0,0.4,0.1,0.7,1.5,1.1
c2,0.6,2.4,1,2.4,1.9c0,1-1,1.6-2.2,1.6C9.2,6.6,8.4,6.1,8,5L8.6,4.9z"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-24"
      />
    </g>
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-27"
      points="181.3,29 181.3,29.8 181.5,29.8 181.1,31 181.4,31 181.9,29.8 181.9,29 "
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-28"
      points="191,24 191,30 195,30 195,29.6 191.7,29.6 191.7,24 "
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-29"
      points="198.2,29.7 198.8,29.7 198.8,29.3 198.2,29.3 "
    />
    <path
      d="M202.7,26.9h1.6c1.4,0,1.9-0.4,1.9-1.2s-0.6-1.2-1.9-1.2h-1.6V26.9z M202,30v-6h2.4
c1.9,0,2.6,0.7,2.6,1.7c0,1-0.8,1.7-2.6,1.7h-1.6V30H202z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-30"
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-32"
      points="209.2,29.7 209.8,29.7 209.8,29.3 209.2,29.3 "
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-33"
      points="38,1 38,20 42,20 42,5.3 47.6,20 52.5,20 57.9,5.6 57.9,20 62,20 62,1.1 55.4,1.1 
50,16.1 44.4,1 "
    />
    <path
      d="M71.9,12.4H77l-2.6-6.6L71.9,12.4z M71.9,1h4.7L85,20h-4.8l-1.6-4.3h-8L68.8,20H64L71.9,1z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-34"
    />
    <g id="Group-43" transform="translate(86.000000, 0.000000)">
      <path
        d="M0.6,10.4c0-5,3.5-9.7,8.6-9.7h12v3.5H10.3c-3,0-4.6,3.2-4.6,6.1c-0.1,3,1.5,6.4,4.5,6.4h6.5
v-4.8h-6.7V8.7h11.3V20H8.5C3.6,20,0.6,15.2,0.6,10.4"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-35"
      />
      <path
        d="M28.2,18.9c-6-2.9-6-14,0-17.1C29.9,1,31.1,0.8,33,0.8h8.8v3.4h-8.1c-1.4,0-2.3,0.3-3.3,1.3
c-0.9,1-1.3,1.9-1.2,3.3h12.7v3.4H29.1c0,1.2,0.3,2.1,1.1,2.9c0.8,1,1.7,1.5,3,1.5h8.5v3.3h-9.4C30.7,19.9,29.7,19.6,28.2,18.9"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-37"
      />
      <path
        d="M49.4,13.1c0,1.1,0.2,1.8,0.9,2.6c1,1.2,2.3,1.4,3.9,1.4h6.2v3.1h-7c-3.6,0-6.8-0.6-8.3-3.7
c-0.5-1.2-0.7-2-0.7-3.3V0.8h5V13.1z"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-39"
      />
      <path
        d="M67.7,13.1c0,1.1,0.2,1.8,0.9,2.6c1,1.2,2.3,1.4,3.9,1.4h6.2v3.1h-7c-3.6,0-6.8-0.6-8.3-3.7
c-0.5-1.2-0.7-2-0.7-3.3V0.8h5V13.1z"
        fill="#213657"
        fillRule="evenodd"
        id="Fill-41"
      />
    </g>
    <path
      d="M173.9,12.4h5.2l-2.6-6.6L173.9,12.4z M173.9,1h4.7l8.3,19h-4.8l-1.6-4.3h-8l-1.7,4.3H166L173.9,1
z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-44"
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-45"
      points="190,2 196.2,2 205.3,16.2 205.3,2 210,2 210,21 203.9,21 194.5,7.1 194.6,20.9 190,20.9 
"
    />
    <polygon
      fill="#0B6825"
      fillRule="evenodd"
      id="Fill-46"
      points="0,1 0,22 9.8,9.6 17.2,17.7 22.4,12.5 32,25 32,1 "
    />
    <polygon
      fill="#0B6825"
      fillRule="evenodd"
      id="Fill-47"
      points="0,24.4 0,31 4.6,31 16,18.6 10.6,15 "
    />
    <polygon fill="#0B6825" fillRule="evenodd" id="Fill-48" points="8,31 32,31 32,26.3 24.4,21 " />
    <path
      d="M212.4,1.9c-0.1-0.3-0.2-0.4-0.4-0.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.4,1.3,0.5,1.3,1.4
c0,0.5-0.4,0.8-1,0.8c-0.5,0-0.9-0.2-1-0.8l0.6-0.1c0.1,0.4,0.3,0.5,0.5,0.5c0.2,0,0.4-0.1,0.4-0.3c0-0.5-1.3-0.6-1.3-1.4
c0-0.5,0.3-0.8,0.9-0.8c0.5,0,0.8,0.3,1,0.7L212.4,1.9z"
      fill="#213657"
      fillRule="evenodd"
      id="Fill-49"
    />
    <polygon
      fill="#213657"
      fillRule="evenodd"
      id="Fill-51"
      points="216.1,1 215.5,3 215.5,3 214.9,1 214,1 214,4 214.6,4 214.6,1.6 214.6,1.6 215.3,4 
215.7,4 216.4,1.6 216.4,1.6 216.4,4 217,4 217,1 "
    />
  </SvgIcon>
);

MagellanLogoColored.propTypes = {
  classes: shape({}),
  sx: shape({}),
};

MagellanLogoColored.defaultProps = {
  classes: {},
  sx: {},
};

export default MagellanLogoColored;
